// Core compound table + hook
export { DataTable } from './DataTable';
export type { DataTableProps, DataTableFeatures } from './DataTable';
export { useDataTable } from './context';
export { useToggleColumnVisibility, useUnfitColumnIds } from './useResponsiveColumns';
